export const exceptionResources = {
  'exception_management.last_update': 'Last Updated',
  'exception_management.exception_detected': 'Exception Detected On',
  'exception_management.exception_type': 'Exception Type',
  'exception_management.status': 'Status',
  'exception_management.owner': 'Owner',
  'exception_management.page_description':
    'View exceptions that our system detected and assign the issue to a member of your organization',
  'exception_management.modify': 'Modify Exception',
  'exception_management.mark_resolved': 'Mark Resolved',
  'exception_management.change_exception_status': 'Change Exception Status',
  'exception_management.reassign': 'Reassign Exception',
  'exception_management.exception_types.NOT_FC_COMPLETE_IN_SLA': 'Not FC Complete',
  'exception_management.exception_types.NOT_DELIVERED_IN_SLA': 'Not Delivered',
  'exception_management.addressed': 'Addressed',
  'exception_management.detected': 'Detected',
  'exception_management.claimed': 'Claimed',
  'exception_management.actions': 'Actions',
};
export type ExceptionResourceKey =
  | 'exception_management.last_update'
  | 'exception_management.exception_detected'
  | 'exception_management.exception_type'
  | 'exception_management.status'
  | 'exception_management.owner'
  | 'exception_management.page_description'
  | 'exception_management.modify'
  | 'exception_management.mark_resolved'
  | 'exception_management.change_exception_status'
  | 'exception_management.reassign'
  | 'exception_management.exception_types.NOT_FC_COMPLETE_IN_SLA'
  | 'exception_management.exception_types.NOT_DELIVERED_IN_SLA'
  | 'exception_management.addressed'
  | 'exception_management.detected'
  | 'exception_management.claimed'
  | 'exception_management.actions';
